import { create } from 'zustand';
import { DealBuilderSavedFormat } from '../pricing-management/hooks/useDatabaseAPI';

export interface TeamData {
  name: string,
  teamId: string
}

interface PricingManagementStore {
  loading: boolean,
  setLoading: (loading: boolean) => void,

  savedDeals: DealBuilderSavedFormat[],
  setSavedDeals: (savedDeals: DealBuilderSavedFormat[]) => void,

  selectedTeam: TeamData | undefined,
  setSelectedTeam: (selectedTeam: TeamData | undefined) => void,
}

const usePricingManagementStore = create<PricingManagementStore>((set) => ({
  loading: false,
  setLoading: (loading: boolean) => set({ loading }),

  savedDeals: [],
  setSavedDeals: (savedDeals: DealBuilderSavedFormat[]) => set({ savedDeals }),

  selectedTeam: undefined,
  setSelectedTeam: (selectedTeam: TeamData | undefined) => set({ selectedTeam }),
}));

export default usePricingManagementStore;
